import {Box, Collapse, Divider, Grid, Hidden, IconButton} from '@mui/material'
import * as React from 'react'
import {useState} from 'react'
import {
  ApprovalStatus,
  BusinessUnit,
  DateFrom,
  DateTo,
  Destination,
  Emergency,
  ItemCode,
  Status,
  VendorCode,
} from '../../../components/SelectBox'
import {ChangeCircle} from '@mui/icons-material'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import PaginationSystem from '../../../components/Pagination/PaginationSystem'
import WaitingForApprovals from '../../Vendor/VendorComponent/WaitingForApprovals'
import Drafts from '../BidComparsionChart/bidsComparisonComponent/Drafts'
import AllComparison from '../BidComparsionChart/bidsComparisonComponent/AllComparison'
import Held from '../BidComparsionChart/bidsComparisonComponent/Held'
import Rejected from '../BidComparsionChart/bidsComparisonComponent/Rejected'
import MyCharts from '../BidComparsionChart/bidsComparisonComponent/MyCharts'
import NotReleased from '../BidComparsionChart/bidsComparisonComponent/NotReleased'
import {CommonTextBox, MultilineTextBox} from '../../../components/TextBox'

const BIDsCardCompany = () => {
    const [open1, setOpen1] = useState(true)

    const handleClick1 = () => {
        setOpen1(!open1)
    }

    const [open2, setOpen2] = useState(true)

    const handleClick2 = () => {
        setOpen2(!open2)
    }

    const [value, setValue] = useState('1')

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    let xlGrid1, xlGrid2, lgGrid1, lgGrid2, mdGrid1, mdGrid2, smGrid1, smGrid2, xsGrid1, xsGrid2
    let xlColumn, lgColumn, mdColumn, smColumn, xsColumn

    //Grid
    xlGrid1 = open2 ? 9 : 11
    xlGrid2 = open2 ? 3 : 1

    lgGrid1 = open2 ? 8 : 11
    lgGrid2 = open2 ? 4 : 1

    mdGrid1 = open2 ? 12 : 12
    mdGrid2 = open2 ? 12 : 12

    smGrid1 = open2 ? 12 : 12
    smGrid2 = open2 ? 12 : 12

    xsGrid1 = open2 ? 12 : 12
    xsGrid2 = open2 ? 12 : 12

    //Column
    xlColumn = open2 ? 2.7 : 2
    lgColumn = open2 ? 2.8 : 2.5
    mdColumn = 3
    smColumn = 5
    xsColumn = 12

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={xsGrid1} sm={smGrid1} md={mdGrid1} lg={lgGrid1} xl={xlGrid1}>
                    <Grid container display="flex" justifyContent="space-between" spacing={3}>
                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <BusinessUnit/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <ItemCode/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="RFQ No"/>
                            </Box>
                        </Grid>

                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="Entered By"/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="BID Number"/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="Comparison No"/>
                            </Box>
                        </Grid>

                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <Destination/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <DateFrom/>
                            </Box>
                            <Box sx={{pb: 2}}>
                                <DateTo/>
                            </Box>
                        </Grid>

                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <MultilineTextBox label="Operator Comment" rows={6}/>
                            </Box>
                        </Grid>
                    </Grid>

                    <Divider textAlign="left">Terms</Divider>

                    <Grid container display="flex" justifyContent="space-between" mt={1} spacing={1}>
                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="Delivery Terms"/>
                            </Box>
                        </Grid>

                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="Delivery Time"/>
                            </Box>
                        </Grid>

                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="Payment Terms"/>
                            </Box>
                        </Grid>

                        <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                            <Box sx={{pb: 2}}>
                                <CommonTextBox label="Expected Other Cost"/>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    item
                    xs={xsGrid2}
                    sm={smGrid2}
                    md={mdGrid2}
                    lg={lgGrid2}
                    xl={xlGrid2}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Hidden smDown mdDown lgDown>
                        <Divider orientation="vertical" flexItem>
                            <IconButton onClick={handleClick2}>
                                <ChangeCircle/>
                            </IconButton>
                        </Divider>
                    </Hidden>

                    <Box>
                        <Collapse in={open2}>{open2 ? <PaginationSystem/> : <Hidden/>}</Collapse>
                    </Box>
                </Grid>
            </Grid>

            <Divider textAlign="left">Vendor and Status Information</Divider>

            <Grid container display="flex" justifyContent="space-between" mt={1}>
                <Grid item xs={12} sm={5} md={2} lg={2} xl={2}>
                    <Box sx={{pb: 2}}>
                        <VendorCode/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Vendor Name"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Address"/>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={5} md={2} lg={2} xl={2}>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Contact"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Email"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Country"/>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={5} md={2} lg={2} xl={2}>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Phone"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="TAX ID"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="TAX Code"/>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={5} md={2} lg={2} xl={2}>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Won"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <Status/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <ApprovalStatus/>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={5} md={2} lg={2} xl={2}>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Currency"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <CommonTextBox label="Discount"/>
                    </Box>
                    <Box sx={{pb: 2}}>
                        <Emergency/>
                    </Box>
                </Grid>
            </Grid>

            <Divider>
                <IconButton onClick={handleClick1}>
                    <ChangeCircle/>
                </IconButton>
            </Divider>

            <Box>
                <Collapse in={open1}>
                    {open1 ? (
                        <Grid container display="flex" justifyContent="space-between" mt={2}>
                            <Grid item xs={12} sm={5} md={2} lg={2} xl={1.5}>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 1"/>
                                </Box>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 2"/>
                                </Box>{' '}
                            </Grid>
                            <Grid item xs={12} sm={5} md={2} lg={2} xl={1.5}>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 3"/>
                                </Box>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 4"/>
                                </Box>{' '}
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={2} xl={1.5}>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 5"/>
                                </Box>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 6"/>
                                </Box>{' '}
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={2} xl={1.5}>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 7"/>
                                </Box>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 8"/>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={3} md={2} lg={2} xl={1.5}>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 9"/>
                                </Box>
                                <Box sx={{pb: 2}}>
                                    <CommonTextBox label="Analysis Code 10"/>
                                </Box>
                            </Grid>
                        </Grid>
                    ) : (
                        <Hidden/>
                    )}
                </Collapse>
            </Box>
            <Grid container spacing={3} mt={1}>
                <Grid item xs={12}>
                    <Box sx={{width: '100%', typography: 'body1'}}>
                        <TabContext value={value}>
                            <Box sx={{width: '100%', typography: 'body1'}}>
                                <TabContext value={value}>
                                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                                            <Tab label="Waiting for Approvals" value="1"/>
                                            <Tab label="Drafts" value="2"/>
                                            <Tab label="All Comparison" value="3"/>
                                            <Tab label="Held" value="4"/>
                                            <Tab label="Rejected" value="5"/>
                                            <Tab label="My Charts" value="6"/>
                                            <Tab label="Not Released" value="7"/>
                                        </TabList>
                                    </Box>
                                    <TabPanel value="1">
                                        <WaitingForApprovals/>
                                    </TabPanel>
                                    <TabPanel value="2">
                                        <Drafts/>
                                    </TabPanel>
                                    <TabPanel value="3">
                                        <AllComparison/>
                                    </TabPanel>
                                    <TabPanel value="4">
                                        <Held/>
                                    </TabPanel>
                                    <TabPanel value="5">
                                        <Rejected/>
                                    </TabPanel>
                                    <TabPanel value="6">
                                        <MyCharts/>
                                    </TabPanel>
                                    <TabPanel value="7">
                                        <NotReleased/>
                                    </TabPanel>
                                </TabContext>
                            </Box>
                        </TabContext>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default BIDsCardCompany
